import { Directive, Input, TemplateRef, ViewContainerRef, Injector } from '@angular/core';
import { AccountService } from 'src/app/core';

/**
 * @whatItDoes Conditionally includes an HTML element if current user has any
 * of the authorities passed as the `expression`.
 *
 * @howToUse
 * ```
 *     <some-element *userAuthority="'ROLE_ADMIN'">...</some-element>
 *
 *     <some-element *userAuthority="['ROLE_ADMIN', 'ROLE_USER']">...</some-element>
 * ```
 */
@Directive({
    selector: '[userAuthority]'
})
export class UserAuthorityDirective {
    private authorities: any;
    constructor(
        private accountService: AccountService,
        private injector: Injector,
        private templateRef: TemplateRef<any>,
        private viewContainerRef: ViewContainerRef) {
            // this.authorizeService = this.injector.get(AuthorizeService);
    }

    @Input()
    set userAuthority(value: string| string[]) {
        // this.authority = authority;
        this.authorities = typeof value === 'string' ? [ <string> value ] : <string[]> value;
        this.updateView();
        // Get notified each time authentication state changes.
        this.accountService.getAuthenticationState().subscribe(identity => this.updateView());
    }

    private updateView(): void {
        let result = this.accountService.hasAuthority(this.authorities);
        this.viewContainerRef.clear();
        if (result) {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
    }
}
